import React, { FunctionComponent, memo, useMemo } from "react";
import { useIntl } from "react-intl";
import { isEqual } from "lodash";

import StatsTable from "components/stats-table";
import BaseCard, { cardLabel, BaseCardProps } from "./BaseCard";
import TransformerState from "../../transformer/TransformerState";

import { SiteConfig_siteConfig_dashboardConf_components } from "graphql/generated";

interface IProps extends BaseCardProps {
  data: any;
  config: SiteConfig_siteConfig_dashboardConf_components;
}

const TransformerCard: FunctionComponent<IProps> = memo(function Transformer({ data, config, ...rest }) {
  const intl = useIntl();

  const statsTableRows = useMemo(() => {
    switch(config.uiVersion) {
      case "risen":
        return [
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__ambient_temp",
              defaultMessage: "Ambient temperature",
            }),
            decimals: 1,
            unit: "°C",
            value: data?.t1,
          },
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__oil_temp",
              defaultMessage: "Oil Temperature",
            }),
            decimals: 1,
            unit: "°C",
            value: data?.t2,
          },
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__status",
              defaultMessage: "Status",
            }),
            value: <TransformerState state={data?.state} />,
          },
        ]
      default:
        return [
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__t1",
              defaultMessage: "Temperature 1",
            }),
            decimals: 1,
            unit: "°C",
            value: data?.t1,
          },
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__t2",
              defaultMessage: "Temperature 2",
            }),
            decimals: 1,
            unit: "°C",
            value: data?.t2,
          },
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__t3",
              defaultMessage: "Temperature 3",
            }),
            unit: "°C",
            decimals: 1,
            value: data?.t3,
          },
          {
            label: intl.formatMessage({
              id: "dashboard__transformer__t4",
              defaultMessage: "Temperature 4",
            }),
            unit: "°C",
            decimals: 1,
            value: data?.t4,
          },
        ]
    }
  }, [data, config.uiVersion, intl])

  return (
    <BaseCard {...rest}
      title={intl.formatMessage({
        id: "dashboard__transformer____title",
        defaultMessage: `{count, plural,
          one {Transformer}
          other {Transformers}
        } {label}`,
      }, {
        ...cardLabel(config),
      })}
      image={"/images/svg/transformator.svg"}
    >
        <StatsTable
          inline
          rows={statsTableRows}
        />
    </BaseCard>
  );
}, isEqual);

export default TransformerCard;
